import { render, staticRenderFns } from "./ModalAssinaturaDigital.vue?vue&type=template&id=0fabac79&scoped=true"
import script from "./ModalAssinaturaDigital.vue?vue&type=script&lang=js"
export * from "./ModalAssinaturaDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fabac79",
  null
  
)

export default component.exports